module.exports = __webpack_public_path__ + "img/wx-share-coupon@3x.f369d5a8.png";